// priorAuthStatus.js — TEST 2.22 (patient half, Dr. Rami R40), P3-2.
// Gate: scripts/check-authorization-status.mjs.
//
// ★ THE CONTRACT (orella-api D6a, D6_PLAN.md section 4.1): a prior authorization the physician
//   generates lives on the case's `caseRequests[]` (docType 'prior_authorization'). Once it is
//   signed or sent, the physician or the practice's MA records the payer's answer on that SAME
//   entry as `payerStatus` ('submitted' | 'approved' | 'denied'; absent = not submitted yet)
//   and `payerReference` (string | null). These keys are NOT `status` (the document's own
//   lifecycle) and the legacy `documents.authorization` entries never carry them.
// ★ ABSENT KEYS = TODAY'S VIEW: an entry without a known payerStatus yields nothing here, so a
//   case on an API without D6a (or a prior auth not yet submitted) renders exactly as before.
// ★ MINIMAL: only the fields the patient's card shows are kept (no title, config, letter text,
//   signature or PDF) — the store holds this projection, not the documents. The title is left
//   out on purpose: the API's default title can carry a CPT code (`<cpt> prior auth`), which
//   the patient app does not show; the card says "Prior authorization" in the patient's language.

export const PAYER_STATUSES = ['submitted', 'approved', 'denied']

export const PAYER_STATUS_KEYS = {
  submitted: 'authDocs.payerSubmitted',
  approved: 'authDocs.payerApproved',
  denied: 'authDocs.payerDenied',
}

export function priorAuthPayerEntries(caseRequests) {
  if (!Array.isArray(caseRequests)) return []
  const out = []
  for (const r of caseRequests) {
    if (!r || typeof r !== 'object' || r._legacy) continue
    if (r.docType !== 'prior_authorization') continue
    if (!PAYER_STATUSES.includes(r.payerStatus)) continue
    const ref = typeof r.payerReference === 'string' ? r.payerReference.trim() : ''
    out.push({
      id: r.id || null,
      payerStatus: r.payerStatus,
      payerReference: ref || null,
      payerStatusAt: r.payerStatusAt || null,
    })
  }
  return out
}
